import { useState } from 'react'
import { useSearchInfluencers } from '@/hooks'
import { useStore } from '@/store'
import { SearchHeader, SearchForm, SearchResults } from '@/components/influencers'

export function SearchPage() {
  const [searchType, setSearchType] = useState<'basic' | 'deep'>('basic')
  const { searchQuery, setSearchQuery } = useStore()
  const searchMutation = useSearchInfluencers()

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    if (!searchQuery.trim()) return
    searchMutation.mutate({ user_query: searchQuery, type: searchType })
  }

  return (
    <div className="space-y-6">
      <SearchHeader />
      
      <SearchForm
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
        searchType={searchType}
        onSearchTypeChange={setSearchType}
        onSubmit={handleSearch}
        isLoading={searchMutation.isPending}
      />

      {searchMutation.data && (
        <SearchResults
          profiles={searchMutation.data.profiles}
          totalProfiles={searchMutation.data.total_profiles}
        />
      )}
    </div>
  )
} 